<template>
  <el-dialog
    :visible.sync="visible"
    :width="width"
    :before-close="handleClose"
    append-to-body
    custom-class="sr-dialog"
    :title="title"
  >
    <div class="dialog_content">
      {{ content }}
      <slot name="content"></slot>
    </div>
    <div class="dialog_footer">
      <slot name="footer"></slot>
      <el-button size="medium" round @click="handleClose" v-if="!isHideCancelBtn"
        >取消</el-button
      >
      <el-button
        round
        size="medium"
        type="primary"
        @click="$emit('ok')"
        v-if="!isHideOkBtn"
      >
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "SrDialog",
  props: {
    // 编辑器中呈现的内容
    visible: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    title: {
      type: String,
      default: function () {
        return "";
      },
    },
    type: {
      type: String,
      default: function () {
        return "success";
      },
    },
    content: {
      type: String,
      default: function () {
        return "";
      },
    },
    width: {
      type: String,
      default: function () {
        return "480";
      },
    },
    isHideCancelBtn: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
    isHideOkBtn: {
      type: Boolean,
      default: function () {
        return false;
      },
    },
  },
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    handleClose() {
      this.$emit("close");
    },
  },
};
</script>


// WEBPACK FOOTER //
// packages/SrDialog/SrDialog.vue